import { usePageStore } from '@/store';
import { searchRealTimeListings } from '@/common/search-request';
import util from '../../common/util';
import * as TYPES from './_store/types'

const PAGE_SIZE = 15;
function generateHttp(params, type, globalData) {
    params = {
        ...params,
        aggType: type,
        aggSize: PAGE_SIZE,
        timezone: this.getCookie('timezone') || util.getTimeZone()
    };
    return searchRealTimeListings.call(this, {
        params,
        type: 'nearby',
        globalData: globalData
    }).then(
        data => (data.data && data.data.listingList) || []
    );
}
export async function fetchData(store, params = {}) {
    const pageStore = usePageStore(this.$pinia)
    const requests = [];
    this.TYPES.forEach(o => {
        requests.push(generateHttp.call(this, params, o.type, pageStore.page));
    });
    try {
        const result = await Promise.all(requests);
        //    console.log('========result===',result,this.mdData.name,params)
        store[TYPES.SET_SEO_DATA](result)
    } catch (e) {
        throw e;
    }
}




export async function asyncData(store) {
    
    if (this.isDetailInfo) {
        const detailInfoData = this.$root.moduleData.filter(
            m => m.name === 'md-detail-info'
        )[0];
        const { latitude, longitude } =
            (detailInfoData &&
                detailInfoData.data &&
                detailInfoData.data.listingDetail &&
                detailInfoData.data.listingDetail.info) ||
            {};
    
        const rect = util.getRectangle(+latitude, +longitude, 10).join(',');
        await fetchData.call(this, store, {
            mapSearch: true,
            rect,
            siteId: this.siteId
        });
    } 
}